import { Loader2 } from "lucide-react";
import React from "react";

type LoaderSize = "sm" | "md" | "lg";
type LoaderVariant = "plain" | "card";

const sizeClassName: Record<LoaderSize, string> = {
  sm: "h-5 w-5",
  md: "h-6 w-6",
  lg: "h-8 w-8",
};

interface CenteredLoaderProps {
  text?: string;
  helperText?: string;
  size?: LoaderSize;
  variant?: LoaderVariant;
  className?: string;
}

const CenteredLoader: React.FC<CenteredLoaderProps> = ({
  text = "Loading…",
  helperText,
  size = "lg",
  variant = "plain",
  className,
}) => {
  const content = (
    <div className="flex flex-col items-center justify-center gap-3 text-center">
      <Loader2
        className={`${sizeClassName[size]} animate-spin text-[color:var(--ops-accent)]`}
        aria-hidden="true"
      />
      {text ? <p className="text-[15px] font-medium text-slate-900">{text}</p> : null}
      {helperText ? <p className="text-[13px] text-slate-600">{helperText}</p> : null}
      <span className="sr-only">{text || "Loading"}</span>
    </div>
  );

  if (variant === "card") {
    return (
      <div className={`grid place-items-center p-6 ${className ?? ""}`}>
        <div className="w-full max-w-sm rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
          {content}
        </div>
      </div>
    );
  }

  return (
    <div className={`grid place-items-center p-6 ${className ?? ""}`}>
      {content}
    </div>
  );
};

export default CenteredLoader;

